import toast from "react-hot-toast";
import * as api from "../Api";

export const getLocationsRequest = () => async (dispatch) => {
  try {
    const { data } = await api.getLocationsRequest();
    dispatch({ type: "GET_ALL_LOCATIONS_REQUEST", payload: data });
  } catch (error) {}
};

export const deleteLocationsRequest = (id) => async (dispatch) => {
  try {
    await api.deleteRequest(id);
    dispatch({ type: "DELETE_ALL_LOCATIONS_REQUEST", payload: id });
  } catch (error) {}
};
export const updateLocationRequest = (id, postData) => async (dispatch) => {
  let submittingId;
  try {
    submittingId = toast.loading("Submitting...");
    await api.updateRequest(id, postData);
    dispatch({ type: "UPDATE REQUEST", payload: id });
    toast.remove(submittingId);
    toast.success("Done!");
    toast.dismiss();
  } catch (error) {
    toast.remove(submittingId);
    toast.dismiss();
    toast.error(error.message);
  }
};
